import {Proof} from './Proof';

export class UserAddress {
    _id?: string;
    address: string;
    state: string;
    pin_code: number;
    city: string;
    proofs: Proof[];
    updatedAt: Date;

    constructor(state: string, pinCode: number, city: string, address?: string, proofs?: Proof[]) {
        this.pin_code = pinCode;
        this.state = state;
        this.city = city;
        this.address = address;
        this.proofs = proofs;
    }
}
